A three-letter ISO 4217 currency code, in uppercase.
